import { render, staticRenderFns } from "./FailView.html?vue&type=template&id=738881fb&"
import script from "./FailView.vue?vue&type=script&lang=ts&"
export * from "./FailView.vue?vue&type=script&lang=ts&"
import style0 from "./FailView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports